import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';
const WorkLifeBalance = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.workLifeBalanceBody} />
    </ArticleBody>
  </div>
);

WorkLifeBalance.propTypes = {};

export default WorkLifeBalance;
